var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaseShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.677 147.832L47.6892 158.08L46.7153 80.1038L56.0269 78.9801L63.3009 78.1036L77.1747 76.4331L98.8692 73.8186L112.226 72.208L116.916 71.6387L131.344 141.442L132.67 147.824L132.677 147.832Z",
    fill: "#E5DDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.899 140.176L132.67 147.832L131.344 141.449L116.916 71.6387L126.145 63.9827L141.899 140.176Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9639 71.6087C63.241 57.7274 70.0281 46.6029 79.085 46.0036C80.366 45.9212 81.617 46.0486 82.8456 46.3707C89.9248 48.2285 95.9328 56.5063 98.0827 67.3686",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3505 69.9905C75.8111 60.3418 78.4181 51.6669 82.8454 46.3706C85.4823 43.2168 88.7634 41.2616 92.4117 41.0219C101.776 40.4076 110.211 51.2699 111.926 65.698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2581 63.9827C44.1609 63.9827 45.7116 62.432 45.7116 60.5217C45.7116 58.6115 44.1684 57.0608 42.2581 57.0608C40.3479 57.0608 38.8047 58.6115 38.8047 60.5217C38.8047 62.432 40.3479 63.9827 42.2581 63.9827Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.624 103.933C175.527 103.933 177.078 102.383 177.078 100.472C177.078 98.5622 175.535 97.0115 173.624 97.0115C171.714 97.0115 170.171 98.5622 170.171 100.472C170.171 102.383 171.714 103.933 173.624 103.933Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4631 97.0114C66.365 98.5021 65.2038 99.7082 63.7655 110.181C62.3272 99.7082 61.166 98.5021 51.0679 97.0114C61.166 95.5206 62.3272 94.3145 63.7655 83.8418C65.2038 94.3145 66.365 95.5206 76.4631 97.0114Z",
    fill: "#21187F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1569 114.249C35.5611 114.204 31.7705 115.792 29.9801 118.916C28.1897 122.04 29.1261 126.677 32.3698 128.235C35.6135 129.793 40.2281 126.766 39.5015 123.246C37.4938 120.818 33.0815 121.725 31.5683 124.489C30.055 127.253 31.0514 130.894 33.2313 133.171C35.4113 135.449 38.5201 136.595 41.5915 137.299C56.117 140.625 71.2118 135.509 84.6886 129.156C102.353 120.833 118.953 110.248 133.943 97.7454C136.618 95.5131 139.419 92.9061 139.891 89.4602C140.363 86.0142 136.895 82.0738 133.719 83.5046",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6368 81.512C47.3296 107.065 47.0225 132.61 46.7153 158.162C65.9903 156.005 85.2652 153.855 104.54 151.697C112.9 150.761 121.276 149.824 129.486 147.997",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5352 67.9455C99.9256 66.4247 112.324 64.904 124.714 63.3833C121.5 65.9902 119.74 67.3911 116.534 69.9981",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.729 69.8257C119.418 79.1223 121.665 88.5388 123.478 98.0451C123.478 97.8429 123.478 97.6406 123.478 97.4309",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.805 47.6142C145.939 47.6142 150.102 43.452 150.102 38.3176C150.102 33.1832 145.939 29.021 140.805 29.021C135.671 29.021 131.508 33.1832 131.508 38.3176C131.508 43.452 135.671 47.6142 140.805 47.6142Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.263 39.4638C158.132 39.9507 159.076 40.5725 159.256 41.5463C159.436 42.4977 158.777 43.4491 157.923 43.9061C157.069 44.363 156.072 44.438 155.106 44.4754C144.363 44.8874 133.516 41.7411 124.669 35.6433C124.055 35.2237 123.388 34.6619 123.418 33.9203C123.455 32.9389 124.624 32.4745 125.59 32.2947",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.633,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaseShopping);
export default __webpack_public_path__ + "static/media/EaseShopping.7e429955f95d12eb7a54f47ccf316884.svg";
export { ForwardRef as ReactComponent };